import React from 'react';
import './PricingBox.sass';
import PropTypes from 'prop-types';
import Button from '../button/Button';
import Title from '../title/Title';
import SmallText from '../smallText/Smalltext';
import LazyLoad from 'react-lazyload';
import i18n from '../../../i18n';
import NewArea from '../newArea/NewArea';

const PricingBox = React.memo(props => {
    var { type, iconSrc, mostSubscribed, titleText, priceText, monthText, billingText, topButtonText, bottomButtonText, children, hrefTopButton, hrefbottomButton, loading } = props;
    var titleType = ' ';
    var priceType = ' ';
    var monthType = ' ';
    var billingType = ' ';
    var topButtonType = ' ';
    var bottomButtonType = ' ';

    var classValue = 'PricingBox ' + type;

    if (type === 'Primary') {
        titleType = 'Secundary';
        priceType = 'Secundary';
        monthType = 'Secundary';
        billingType = 'Secundary';
        topButtonType = 'PrimaryPricingButton';
        bottomButtonType = 'Transparentfourth';
    }
    else if (type === 'Secundary') {
        titleType = 'Fourth';
        priceType = 'Fourth';
        monthType = 'Tertiary';
        billingType = 'Tertiary';
        topButtonType = 'SecundaryPricingButton';
        bottomButtonType = 'TransparentFifth';
    }

    var html = <div className={classValue}>
        <div className="PricingBoxiconArea">
            <LazyLoad offset={200} height={100}>
                <img src={iconSrc} alt="PriceBoxIcon" />
            </LazyLoad>
        </div>
        {mostSubscribed && <div className='PricingBoxLabel'>
            {i18n.t('Most Subscribed')}
        </div>}
        <div style={mostSubscribed ? { marginTop: '2px' } : {}} className="PricingBoxTitleArea">
            <Title size="Small" type={titleType} text={titleText} />
        </div>
        <div className={'PricingBoxPriceTopArea' + (loading ? ' loadingArea' : '')}>
            <Title size="Medium" type={priceType} text={priceText} />
            <SmallText size="Bigger" type={monthType} font="SofiaProRegular" text={monthText} />
        </div>
        <div className="PricingBoxPriceBottomArea">
            <SmallText size="Big" type={billingType} font="SofiaProLight" text={billingText} />
            <SmallText size="Big" type='Fifth' style font="SofiaProLightItalic" text={i18n.t('Save 15% with yearly payments')} />
        </div>
        <div className="PricingBoxPriceCategoryArea">
            {children}
        </div>
        <div className="PricingBoxButtonArea">
            <Button onClick={hrefTopButton} size="Small" type={topButtonType} text={topButtonText} />
            <a href={hrefbottomButton}> <Button size="Small" type={bottomButtonType} text={bottomButtonText} /> </a>
        </div>
    </div>;
    return html;
});

export const PricingBoxPriceCategory = React.memo(props => {
    var { categoryType, categoryText, isNew } = props;
    var classValue = 'PricingBoxPriceCategory ' + categoryType;

    var categoryTextType = 'Secundary';

    var startText = categoryText.indexOf('|') + 1;
    var endText = categoryText.indexOf('|', startText);
    var text_to_get = categoryText.substring(startText, endText);

    var startdisableText = categoryText.indexOf('*') + 1;
    var enddisableText = categoryText.indexOf('*', startdisableText);
    var text_to_getdisable = categoryText.substring(startdisableText, enddisableText);


    if (startdisableText > 0) {
        var disableIcon = true;
        categoryText = categoryText.replace(`*${text_to_getdisable}*`, `<span class = "PriceDisable" >${text_to_getdisable}</span>`);
        var someHtml = categoryText;
        return (
            <div className={classValue}>
                <div className={disableIcon ? 'PricingBoxPriceCategoryIconDisable' : 'PricingBoxPriceCategoryIcon'} />
                <div className="PricingBoxPriceCategoryText">
                    <SmallText size="Bigger" type={categoryTextType} font="SofiaProRegular" html={someHtml} />
                </div>
            </div>
        );
    }
    else {
        if (categoryType === 'Primary') {
            categoryText = categoryText.replace(`|${text_to_get}|`, `<span class = "PriceBlue" >${text_to_get}</span>`);
        }
        else if (categoryType === 'Secundary') {
            categoryText = categoryText.replace(`|${text_to_get}|`, `<span class = "PricePurple" >${text_to_get}</span>`);
        }

        someHtml = categoryText;

        return (
            <div className={classValue}>
                <div className="PricingBoxPriceCategoryIcon" />
                <div className="PricingBoxPriceCategoryText">
                    <SmallText size="Bigger" type={categoryTextType} font="SofiaProRegular" html={someHtml} text="" />
                    {isNew && <NewArea style={{ marginLeft: '4px' }} />}
                </div>
            </div>
        );
    }
});

PricingBox.propTypes = {
    type: PropTypes.oneOf(['Primary', 'Secundary']),
    titleText: PropTypes.string,
    priceText: PropTypes.any,
    monthText: PropTypes.string,
    billingText: PropTypes.string,
    topButtonText: PropTypes.string,
    bottomButtonText: PropTypes.string,
};

PricingBox.defaultProps = {
    type: 'Primary',
    titleText: 'Friendly',
    priceText: '47.99€',
    monthText: '/month',
    billingText: 'Billed monthly',
    topButtonText: 'Experimentar agora',
    bottomButtonText: 'Saber mais',
};

PricingBoxPriceCategory.PropType = {
    categoryType: PropTypes.oneOf(['Primary', 'Secundary'])
};

PricingBoxPriceCategory.defaultProps = {
    categoryType: 'Primary'
};

export default PricingBox;
